/* eslint-disable no-eval */
/* eslint-disable no-promise-executor-return */
/* eslint-disable prefer-destructuring */
/* eslint-disable no-nested-ternary */
/* eslint-disable react/jsx-props-no-spreading */
import React, { useState, useContext, useEffect } from 'react'
import PropTypes from 'prop-types'
import { DragDropContext, Droppable, Draggable } from '@hello-pangea/dnd'
import { Image, Button, Form } from 'react-bootstrap'
import { DraftContext } from './ContextProvider'
import SidebarClose from './SidebarClose'
import AllEditor from './AllEditor'
// import Gallery from '../tools/Gallery'
import StoryCard from './StoryCard'
import CardTool from './CardTool'
import TootipItem from './TootipItem'
import { ImgCard, Label, TextArea } from '../tools'
import { usePersonaStore } from '../store'

function DragWrapper({ setting }) {
  const {
    // module = {},
    moduleList = {},
    user_info,
    quote = [],
    characteristics_and_focus = [],
    onDragEnd,
    boardStyle,
    handleInputChange = () => {},
    removeCard = () => {},
    showToolbar = false,
    constList,
  } = setting
  const {
    editDetail,
    componentType,
    setComponentType,
    sidebar,
    showWarn,
    setShowWarn,
  } = useContext(DraftContext)
  const [showDetail] = useState(false)
  const [editList, setEditList] = useState(editDetail[componentType])

  const setType = (type) => {
    setComponentType(type)
    setEditList(editDetail[type])
  }

  const dragAreaStyle = (isDraggingOver) => ({
    border: isDraggingOver ? '1px dashed #4099ff' : '',
  })

  const dragItemStyle = (isDragging, draggableStyle) => ({
    userSelect: 'none',
    border: isDragging ? '2px solid #717477' : 'none',
    ...draggableStyle,
  })

  const transToQuote = (array) => {
    let res = ''
    for (let index = 0; index < array.length; index += 1) {
      res += `<blockquote>${array[index]}</blockquote>`
    }
    return res
  }

  // loading
  const [showLoading, setShowLoading] = useState(true)
  const [badgeLoading, setBadgeLoading] = useState(true)
  useEffect(() => {
    if (showLoading) {
      setTimeout(() => {
        setShowLoading(false)
        setBadgeLoading(false)
      }, 1000)
    }
  }, [])

  const handleRegenerate = () => {
    setBadgeLoading(true)
    setTimeout(() => {
      setBadgeLoading(false)
    }, 1000)
  }

  const { updateUserInfo, updateQuote, updateHaP } = usePersonaStore(
    (store) => ({
      updateUserInfo: store.updateUserInfo,
      updateQuote: store.updateQuote,
      updateHaP: store.updateHaP,
    })
  )
  console.log(user_info)
  console.log(quote)

  return (
    <DragDropContext onDragEnd={onDragEnd}>
      {showToolbar && (
        <>
          <Component setting={{ setType }} />
          <ComponentDetail
            setting={{
              show: showDetail,
              list: editList,
            }}
          />
        </>
      )}
      <div className={`edit-block ${sidebar ? 'open' : ''}`}>
        <div className="row">
          <div>
            {boardStyle === 'vertical' ? (
              <div className="d-xl-flex flex-wrap align-items-start">
                <div className="info-header-img">
                  <ImgCard
                    setting={{
                      img: user_info?.gallery ? user_info?.gallery[0] : '',
                    }}
                  />
                </div>
                {/* <div className="story-left">
                  <Gallery
                    setting={{ imgs: user_info?.gallery || [], setType }}
                  />
                </div> */}
                <div className="story-right">
                  <div className="position-relative ">
                    <div className="card-tool">
                      <CardTool
                        setting={{
                          handleRegenerate: () => handleRegenerate(0),
                          onlyRegenerate: true,
                          hideRegenerate: true,
                        }}
                      />
                    </div>
                    <ul className="spec">
                      {(user_info.name || user_info.isLoading) && (
                        <PersonLabel
                          setting={{
                            labelTitle: '姓名',
                            name: 'name',
                            placeholder: '姓名',
                            value: user_info.name || '',
                            itemLoading: user_info.isLoading,
                            textEdit: (l, v) => {
                              updateUserInfo(l, v)
                            },
                          }}
                        />
                      )}
                      {(user_info.age || user_info.isLoading) && (
                        <PersonLabel
                          setting={{
                            labelTitle: '年齡',
                            name: 'age',
                            placeholder: '年齡',
                            value: user_info.age || '',
                            itemLoading: user_info.isLoading,
                            textEdit: (l, v) => {
                              updateUserInfo(l, v)
                            },
                          }}
                        />
                      )}
                      {(user_info.gender || user_info.isLoading) && (
                        <PersonLabel
                          setting={{
                            labelTitle: '性別',
                            name: 'gender',
                            placeholder: '性別',
                            value: user_info.gender || '',
                            itemLoading: user_info.isLoading,
                            textEdit: (l, v) => {
                              updateUserInfo(l, v)
                            },
                          }}
                        />
                      )}
                      {(user_info.occupation || user_info.isLoading) && (
                        <PersonLabel
                          setting={{
                            labelTitle: '職業',
                            name: 'occupation',
                            placeholder: '職業',
                            value: user_info.occupation || '',
                            itemLoading: user_info.isLoading,
                            textEdit: (l, v) => {
                              updateUserInfo(l, v)
                            },
                          }}
                        />
                      )}
                      {(user_info.family_status || user_info.isLoading) && (
                        <PersonLabel
                          setting={{
                            labelTitle: '家庭狀況',
                            name: 'family_status',
                            placeholder: '家庭狀況',
                            value: user_info.family_status || '',
                            itemLoading: user_info.isLoading,
                            textEdit: (l, v) => {
                              updateUserInfo(l, v)
                            },
                          }}
                        />
                      )}
                      {(user_info.frequently_used_items ||
                        user_info.isLoading) && (
                        <PersonLabel
                          setting={{
                            labelTitle: '常用物件',
                            name: 'commonItems',
                            placeholder: '常用物件',
                            value: user_info.frequently_used_items || '',
                            itemLoading: user_info.isLoading,
                            textEdit: (l, v) => {
                              updateUserInfo(l, v)
                            },
                          }}
                        />
                      )}
                    </ul>
                    <div className="badge-label-text label-text">個性</div>

                    <div className="  position-relative has-drag mb-5">
                      {badgeLoading && <Loading setting={{ style: 'one' }} />}

                      <div className="card-tool pos-right">
                        <CardTool
                          setting={{
                            handleRegenerate: () => handleRegenerate(),
                            onlyRegenerate: true,
                          }}
                        />
                      </div>
                      <div className="badges-group position-relative has-drag">
                        <div className={`fade ${badgeLoading ? '' : 'show'}`}>
                          {characteristics_and_focus.map((item, index) => (
                            <span key={index} className="badge rounded-pill">
                              {item}
                            </span>
                          ))}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              <div>
                <div className="story-header">
                  <div className="info-header-img">
                    <ImgCard
                      setting={{
                        img: user_info?.gallery ? user_info?.gallery[0] : '',
                      }}
                    />
                  </div>
                  {/* <Gallery
                    setting={{ imgs: user_info?.gallery || [], setType }}
                  /> */}
                  <div className="story-right horizon">
                    {user_info.name && (
                      <div className="story-name">
                        <strong>姓名</strong>
                        <Form.Control
                          name="name"
                          type="text"
                          placeholder="姓名"
                          defaultValue={user_info.name}
                          onChange={(e) => {
                            updateUserInfo(e.target.name, e.target.value)
                          }}
                        />
                      </div>
                    )}
                    <div className="position-relative flex-1">
                      <div className="card-tool">
                        <CardTool
                          setting={{
                            handleRegenerate: () => handleRegenerate(0),
                            onlyRegenerate: true,
                            hideRegenerate: true,
                          }}
                        />
                      </div>
                      <ul className="spec border-left">
                        {user_info.age && (
                          <PersonLabel
                            setting={{
                              labelTitle: '年齡',
                              name: 'age',
                              placeholder: '年齡',
                              value: user_info.age,
                              itemLoading: user_info.isLoading,
                              textEdit: (l, v) => {
                                updateUserInfo(l, v)
                              },
                            }}
                          />
                        )}
                        {user_info.gender && (
                          <PersonLabel
                            setting={{
                              labelTitle: '性別',
                              name: 'gender',
                              placeholder: '性別',
                              value: user_info.gender,
                              itemLoading: user_info.isLoading,
                              textEdit: (l, v) => {
                                updateUserInfo(l, v)
                              },
                            }}
                          />
                        )}
                        {user_info.occupation && (
                          <PersonLabel
                            setting={{
                              labelTitle: '職業',
                              name: 'occupation',
                              placeholder: '職業',
                              value: user_info.occupation,
                              itemLoading: user_info.isLoading,
                              textEdit: (l, v) => {
                                updateUserInfo(l, v)
                              },
                            }}
                          />
                        )}
                        {user_info.family_status && (
                          <PersonLabel
                            setting={{
                              labelTitle: '家庭狀況',
                              name: 'family_status',
                              placeholder: '家庭狀況',
                              value: user_info.family_status,
                              itemLoading: user_info.isLoading,
                              textEdit: (l, v) => {
                                updateUserInfo(l, v)
                              },
                            }}
                          />
                        )}
                        {user_info.frequently_used_items && (
                          <PersonLabel
                            setting={{
                              labelTitle: '常用物件',
                              name: 'commonItems',
                              placeholder: '常用物件',
                              value: user_info.frequently_used_items,
                              itemLoading: user_info.isLoading,
                              textEdit: (l, v) => {
                                updateUserInfo(l, v)
                              },
                            }}
                          />
                        )}
                      </ul>
                    </div>
                  </div>
                </div>
                <div className="badge-label-text label-text">個性</div>
                <div className="badges-group position-relative has-drag">
                  <div className="card-tool">
                    <CardTool
                      setting={{
                        handleRegenerate: () => handleRegenerate(3),
                        onlyRegenerate: true,
                      }}
                    />
                  </div>
                  {badgeLoading && <Loading setting={{ style: 'one' }} />}
                  <div className={`fade ${badgeLoading ? '' : 'show'}`}>
                    {characteristics_and_focus.map((item, index) => (
                      <span key={index} className="badge rounded-pill">
                        {item}
                      </span>
                    ))}
                  </div>
                </div>
              </div>
            )}
            <div className="card-wrapper">
              {boardStyle === 'horizon' && (
                <div className="story-info">
                  <div className="card-wrapper">
                    <div className="position-relative has-drag">
                      <StoryCard
                        setting={{
                          label: '動機與行為',
                          text: user_info.motivations_and_behaviors,
                          className: 'hor-card',
                          icon: '/images/svgicons/story-icon04.svg',
                          isLoading: user_info.isLoading,
                          textEdit: (a, b, v) => {
                            console.log(v)
                            // updateUserInfo('motivations_and_behaviors', v)
                          },
                        }}
                      />
                    </div>
                    <div className="position-relative has-drag">
                      <StoryCard
                        setting={{
                          label: 'Quote',
                          text: transToQuote(quote),
                          className: 'hor-card',
                          icon: '/images/svgicons/story-icon05.svg',
                          isLoading: user_info.isLoading,
                          textEdit: (a, b, v) => {
                            console.log(v)
                          },
                        }}
                      />
                    </div>
                  </div>
                  {constList.map(({ title, content }, index) => (
                    <div key={index} className="position-relative has-drag">
                      <StoryCard
                        key={`storyInfo${index}`}
                        setting={{
                          label: `${title}`,
                          text: content,
                          className: 'hor-card',
                          icon: `/images/svgicons/story-icon0${
                            (index % 5) + 1
                          }.svg`,
                          isLoading: user_info.isLoading,
                        }}
                      />
                    </div>
                  ))}
                </div>
              )}
              {boardStyle === 'vertical' && (
                <div className="card-wrapper">
                  <div className="module-control">
                    <div className="row row-item">
                      {quote && quote.map && (
                        <div className="blockquote-list col-xl-6">
                          {quote.map((text, index) => (
                            <blockquote
                              key={`blockquote${index}`}
                              className="blockquote"
                            >
                              <div className="inner">
                                <TextArea
                                  setting={{
                                    label: '',
                                    value: text,
                                    isLoading: quote.isLoading,
                                    textEdit: (a, b, v) => {
                                      console.log(v)
                                      updateQuote(index, v)
                                      // updateQuote(index, v)
                                    },
                                  }}
                                />
                              </div>
                            </blockquote>
                          ))}
                        </div>
                      )}
                      <div className="col-xl-6 position-relative has-drag mb-5">
                        <StoryCard
                          setting={{
                            label: '動機與行為',
                            text: user_info.motivations_and_behaviors,
                            className: 'inner shadow-block',
                            isLoading: user_info.isLoading,
                            textEdit: (a, b, v) => {
                              updateUserInfo('motivations_and_behaviors', v)
                              console.log(v)
                            },
                          }}
                        />
                      </div>
                      {constList.map(({ title, content, isLoading }, index) => (
                        <div
                          className="col-xl-6 position-relative has-drag mb-5"
                          key={`constList_${index}`}
                        >
                          <div className="inner shadow-block">
                            <div
                              style={{
                                marginLeft: '-20px',
                                marginRight: '-20px',
                              }}
                            >
                              <Label
                                setting={{
                                  label: '',
                                  title,
                                  edit: true,
                                  // textEdit: (a, b, v) => {
                                  //   console.log(v)
                                  //   updateHaP()
                                  // },
                                }}
                              />
                              {isLoading ? (
                                <Loading setting={{ style: 'muti' }} />
                              ) : (
                                <TextArea
                                  setting={{
                                    label: '',
                                    value: content,
                                    showLoading,
                                    textEdit: (a, b, value) => {
                                      if (!value) return
                                      const splited = value.split('\n')
                                      console.log(
                                        splited
                                          .slice(1, splited.length - 1)
                                          .map((s) =>
                                            s
                                              .replace('<li>', '')
                                              .replace('</li>', '')
                                          )
                                      )
                                      updateHaP(
                                        index,
                                        'content',
                                        splited
                                          .slice(1, splited.length - 1)
                                          .map((s) =>
                                            s
                                              .replace('<li>', '')
                                              .replace('</li>', '')
                                          )
                                      )
                                    },
                                  }}
                                />
                              )}
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              )}
            </div>
            {boardStyle === 'vertical' && (
              <div className="feature-list position-relative has-drag mb-5">
                <div className="card-tool pos-left">
                  <CardTool
                    setting={{
                      handleRegenerate: () => handleRegenerate(),
                      onlyRegenerate: true,
                    }}
                  />
                </div>
              </div>
            )}
          </div>

          {Object.keys(moduleList).map((cardKey) => (
            <Droppable key={cardKey} droppableId={cardKey}>
              {(cprovided, csnapshot) => (
                <div
                  key={cardKey}
                  className="stage-section"
                  ref={cprovided.innerRef}
                  style={dragAreaStyle(csnapshot.isDraggingOver)}
                >
                  <div className="card-wrapper">
                    {moduleList[cardKey].cards.length === 0 ? (
                      <div className="empty-placeholder">Drop items here</div>
                    ) : (
                      moduleList[cardKey].cards.map(
                        ({ id, type, content }, index) => (
                          <Draggable key={id} draggableId={id} index={index}>
                            {(dragProvided, dragSnapshot) => (
                              <div
                                ref={dragProvided.innerRef}
                                {...dragProvided.draggableProps}
                                style={dragItemStyle(
                                  dragSnapshot.isDragging,
                                  dragProvided.draggableProps.style
                                )}
                                className="dragrow has-drag"
                              >
                                <TootipItem title="拖曳變更排序">
                                  <div
                                    className="drag-bar"
                                    {...dragProvided.dragHandleProps}
                                  >
                                    <div className="module-control-btn">
                                      <Image
                                        src="/images/toolicons/drag.svg"
                                        alt=""
                                      />
                                    </div>
                                  </div>
                                </TootipItem>
                                <div className="module-control">
                                  <div
                                    className="card-tool"
                                    style={{
                                      left: '10%',
                                      right: 'auto',
                                    }}
                                  >
                                    <TootipItem title="移除">
                                      <Button
                                        className="btn-text"
                                        onClick={() => {
                                          setShowWarn({
                                            ...showWarn,
                                            show: true,
                                            text: '確定移除元件？',
                                            func: () => {
                                              removeCard(cardKey, id)
                                            },
                                          })
                                        }}
                                      >
                                        <div
                                          className="svgIcon"
                                          style={{
                                            maskImage: `url('/images/svgicons/trash.svg')`,
                                          }}
                                        >
                                          刪除
                                        </div>
                                      </Button>
                                    </TootipItem>
                                  </div>
                                  <AllEditor
                                    setting={{
                                      id,
                                      label: cardKey,
                                      type,
                                      content,
                                      handleInputChange,
                                      index,
                                    }}
                                  />
                                </div>
                              </div>
                            )}
                          </Draggable>
                        )
                      )
                    )}
                    {cprovided.placeholder}
                  </div>
                </div>
              )}
            </Droppable>
          ))}
        </div>
      </div>
    </DragDropContext>
    // <DragDropContext onDragEnd={onDragEnd}>
    //   {showToolbar && (
    //     <>
    //       <Component setting={{ setType }} />
    //       <ComponentDetail
    //         setting={{
    //           show: showDetail,
    //           list: editList,
    //         }}
    //       />
    //     </>
    //   )}
    //   <div className={`edit-block ${sidebar ? 'open' : ''}`}>
    //     <div className="row">
    //       <div>
    //       {boardStyle === 'vertical' ? (
    //           <div className="d-xl-flex flex-wrap align-items-start">
    //             <div className="story-left">
    //               <Gallery
    //                 setting={{ imgs: user_info?.gallery || [], setType }}
    //               />
    //             </div>
    //       <div className="d-flex flex-wrap">
    //         <div className="story-left">
    //           <Gallery setting={{ imgs: user_info?.gallery || [], setType }} />
    //           <div className="card-wrapper">
    //             <StoryCard
    //               setting={{
    //                 label: '動機與行為',
    //                 text: user_info.motivations_and_behaviors,
    //                 isLoading: user_info.isLoading,
    //               }}
    //             />
    //             <StoryCard
    //               setting={{
    //                 label: '',
    //                 text: transToQuote(quote.quote || []),
    //                 isLoading: quote.isLoading,
    //               }}
    //             />
    //           </div>
    //         </div>
    //         <div className="story-right">
    //           {user_info.isLoading ? (
    //             <Loading setting={{ style: 'one' }} />
    //           ) : (
    //             <ul className="spec">
    //               {user_info.name ? (
    //                 <li>
    //                   <span className="label-text">姓名</span>
    //                   <Form.Control
    //                     name="name"
    //                     type="text"
    //                     placeholder="姓名"
    //                     defaultValue={user_info.name}
    //                     onChange={() => {}}
    //                   />
    //                 </li>
    //               ) : (
    //                 <li>
    //                   <span className="label-text">姓名</span>
    //                   <Form.Control
    //                     name="name"
    //                     type="text"
    //                     placeholder="姓名"
    //                     // defaultValue={user_info.name}
    //                     // onChange={() => {}}
    //                     disabled
    //                   />
    //                 </li>
    //               )}
    //               {user_info.age ? (
    //                 <li>
    //                   <span className="label-text">年齡</span>
    //                   <Form.Control
    //                     name="age"
    //                     type="text"
    //                     placeholder="年齡"
    //                     defaultValue={user_info.age}
    //                     onChange={() => {}}
    //                   />
    //                 </li>
    //               ) : (
    //                 <li>
    //                   <span className="label-text">年齡</span>
    //                   <Form.Control
    //                     name="age"
    //                     type="text"
    //                     placeholder="年齡"
    //                     // defaultValue={user_info.age}
    //                     // onChange={() => {}}
    //                     disabled
    //                   />
    //                 </li>
    //               )}
    //               {user_info.gender ? (
    //                 <li>
    //                   <span className="label-text">性別</span>
    //                   <Form.Control
    //                     name="gender"
    //                     type="text"
    //                     placeholder="性別"
    //                     defaultValue={user_info.gender}
    //                     onChange={() => {}}
    //                   />
    //                 </li>
    //               ) : (
    //                 <li>
    //                   <span className="label-text">性別</span>
    //                   <Form.Control
    //                     name="gender"
    //                     type="text"
    //                     placeholder="性別"
    //                     // defaultValue={user_info.age}
    //                     // onChange={() => {}}
    //                     disabled
    //                   />
    //                 </li>
    //               )}
    //               {user_info.occupation ? (
    //                 <li>
    //                   <span className="label-text">職業</span>
    //                   <Form.Control
    //                     name="occupation"
    //                     type="text"
    //                     placeholder="職業"
    //                     defaultValue={user_info.occupation}
    //                     onChange={() => {}}
    //                   />
    //                 </li>
    //               ) : (
    //                 <li>
    //                   <span className="label-text">職業</span>
    //                   <Form.Control
    //                     name="occupation"
    //                     type="text"
    //                     placeholder="職業"
    //                     // defaultValue={user_info.occupation}
    //                     // onChange={() => {}}
    //                     disabled
    //                   />
    //                 </li>
    //               )}
    //               {user_info.family_status ? (
    //                 <li>
    //                   <span className="label-text">家庭狀況</span>
    //                   <Form.Control
    //                     name="family_status"
    //                     type="text"
    //                     placeholder="家庭狀況"
    //                     defaultValue={user_info.family_status}
    //                     onChange={() => {}}
    //                   />
    //                 </li>
    //               ) : (
    //                 <li>
    //                   <span className="label-text">家庭狀況</span>
    //                   <Form.Control
    //                     name="family_status"
    //                     type="text"
    //                     placeholder="家庭狀況"
    //                     // defaultValue={user_info.family_status}
    //                     // onChange={() => {}}
    //                     disabled
    //                   />
    //                 </li>
    //               )}
    //               {user_info.frequently_used_items ? (
    //                 <li>
    //                   <span className="label-text">常用物件</span>
    //                   <Form.Control
    //                     name="commonItems"
    //                     type="text"
    //                     placeholder="常用物件"
    //                     defaultValue={user_info.frequently_used_items}
    //                     onChange={() => {}}
    //                   />
    //                 </li>
    //               ) : (
    //                 <li>
    //                   <span className="label-text">常用物件</span>
    //                   <Form.Control
    //                     name="commonItems"
    //                     type="text"
    //                     placeholder="常用物件"
    //                     // defaultValue={user_info.frequently_used_items}
    //                     // onChange={() => {}}
    //                     disabled
    //                   />
    //                 </li>
    //               )}
    //             </ul>
    //           )}
    //           <div className="badges-group">
    //             {characteristics_and_focus.map((item, index) => (
    //               <span key={index} className="badge rounded-pill bg-white">
    //                 {item}
    //               </span>
    //             ))}
    //           </div>
    //         </div>
    //       </div>

    //       <div className="stage-section">
    //         <div className="card-wrapper">
    //           <div className="module-control">
    //             <div className="row row-item ">
    //               {constList.map((content, index) => (
    //                 <div className="col-6 mb-5" key={`constList_${index}`}>
    //                   <AllEditor
    //                     setting={{
    //                       type: 'story-card',
    //                       content,
    //                       handleInputChange,
    //                       index,
    //                     }}
    //                   />
    //                 </div>
    //               ))}
    //             </div>
    //           </div>
    //         </div>
    //       </div>

    //       {Object.keys(moduleList).map((cardKey) => (
    //         <Droppable key={cardKey} droppableId={cardKey}>
    //           {(cprovided, csnapshot) => (
    //             <div
    //               key={cardKey}
    //               className="stage-section"
    //               ref={cprovided.innerRef}
    //               style={dragAreaStyle(csnapshot.isDraggingOver)}
    //             >
    //               <div className="card-wrapper">
    //                 {moduleList[cardKey].cards.length !== 0 ? (
    //                   <div className="empty-placeholder">Drop items here</div>
    //                 ) : (
    //                   moduleList[cardKey].cards.map(
    //                     ({ id, type, content }, index) => (
    //                       <Draggable key={id} draggableId={id} index={index}>
    //                         {(dragProvided, dragSnapshot) => (
    //                           <div
    //                             ref={dragProvided.innerRef}
    //                             {...dragProvided.draggableProps}
    //                             style={dragItemStyle(
    //                               dragSnapshot.isDragging,
    //                               dragProvided.draggableProps.style
    //                             )}
    //                             className="dragrow has-drag"
    //                           >
    //                             <div
    //                               className="drag-bar"
    //                               {...dragProvided.dragHandleProps}
    //                             >
    //                               <div className="module-control-btn">
    //                                 <Image
    //                                   src="/images/toolicons/drag.svg"
    //                                   alt=""
    //                                 />
    //                               </div>
    //                             </div>
    //                             <div className="module-control">
    //                               <div
    //                                 className="card-tool"
    //                                 style={{
    //                                   left: '10%',
    //                                   right: 'auto',
    //                                 }}
    //                               >
    //                                 <Button
    //                                   className="btn-text"
    //                                   onClick={() => {
    //                                     setShowWarn({
    //                                       ...showWarn,
    //                                       show: true,
    //                                       text: '確定移除元件？',
    //                                       func: () => {
    //                                         removeCard(cardKey, id)
    //                                       },
    //                                     })
    //                                   }}
    //                                 >
    //                                   <div
    //                                     className="svgIcon"
    //                                     style={{
    //                                       maskImage: `url('/images/svgicons/trash.svg')`,
    //                                     }}
    //                                   >
    //                                     刪除
    //                                   </div>
    //                                 </Button>
    //                               </div>
    //                               <AllEditor
    //                                 setting={{
    //                                   id,
    //                                   label: cardKey,
    //                                   type,
    //                                   content,
    //                                   handleInputChange,
    //                                   index,
    //                                 }}
    //                               />
    //                             </div>
    //                           </div>
    //                         )}
    //                       </Draggable>
    //                     )
    //                   )
    //                 )}
    //                 {cprovided.placeholder}
    //               </div>
    //             </div>
    //           )}
    //         </Droppable>
    //       ))}
    //     </div>
    //   </div>
    // </DragDropContext>
  )
}

// 人物標籤
function PersonLabel({ setting }) {
  const {
    labelTitle = '',
    name = '',
    value,
    placeholder = '',
    itemLoading,
    textEdit = () => {},
  } = setting
  console.log(itemLoading)

  return (
    <li>
      <span className="label-text">{labelTitle}</span>
      <div className="col position-relative">
        {itemLoading && <Loading setting={{ style: 'one' }} />}
        <div className={`fade ${itemLoading ? '' : 'show'}`}>
          <Form.Control
            name={name}
            type="text"
            placeholder={placeholder}
            defaultValue={value}
            onChange={(e) => {
              textEdit(name, e.target.value)
            }}
          />
        </div>
      </div>
    </li>
  )
}

// 拖拉元件
function Component({ setting }) {
  const { setType } = setting
  const [currentEle, setCurrentEle] = useState(0)
  const { editItems, openSidebar, sidebar } = useContext(DraftContext)

  return (
    <div className={`edit-components ${sidebar ? 'show' : ''}`}>
      <div className="scroll-sidebar">
        <div className="sidebar-wrap">
          {editItems.map((item, index) => (
            <Button
              key={`item-${index}`}
              className="edit-item btn-text"
              active={item.id === currentEle}
              onClick={() => {
                setType(item.type)
                setCurrentEle(item.id)
                openSidebar()
              }}
            >
              <div className="edit-item-icon">
                <Image
                  src={`/images/toolicons/${item.icon}`}
                  className="mx-0"
                  alt=""
                />
              </div>
              {item.name}
            </Button>
          ))}
        </div>
      </div>
    </div>
  )
}

function ComponentDetail({ setting }) {
  const { list } = setting
  const { sidebar } = useContext(DraftContext)

  // const getItemStyle = (isDragging, draggableStyle) => ({
  //   userSelect: 'none',
  //   background: isDragging ? 'transparent' : '',
  //   ...draggableStyle,
  // })

  // const getListStyle = (isDraggingOver) => ({
  //   background: isDraggingOver ? '#00FF00' : '#FF0000',
  // })

  return (
    <div className={`component-detail ${sidebar ? 'show' : ''}`}>
      <div className="inner position-relative">
        <div className="scroll-sidebar">
          <div className="sidebar-wrap">
            <Droppable droppableId="elements" isDropDisabled>
              {(provided) => (
                <div
                  {...provided.droppableProps}
                  ref={provided.innerRef}
                  // style={getListStyle(snapshot.isDraggingOver)}
                >
                  {list.map((item, index) => (
                    <Draggable
                      key={`${item.id}`}
                      draggableId={`${item.id}`}
                      index={index}
                    >
                      {(dragProvided, dragSnapshot) => (
                        <React.Fragment key={index}>
                          <div
                            className="snippet-item"
                            ref={dragProvided.innerRef}
                            {...dragProvided.draggableProps}
                            {...dragProvided.dragHandleProps}
                            // style={getItemStyle(
                            //   dragSnapshot.isDragging,
                            //   dragProvided.draggableProps.style
                            // )}
                          >
                            <div className="elememt">
                              {item.img ? (
                                <Image
                                  src={`/images/tools/${item.img}`}
                                  alt=""
                                  className="w-100"
                                />
                              ) : (
                                item.name
                              )}
                            </div>
                          </div>
                          {dragSnapshot.isDragging && (
                            <div className="elememt clone-item">
                              <Image
                                src={`/images/tools/${item.img}`}
                                alt=""
                                className="w-100"
                              />
                            </div>
                          )}
                        </React.Fragment>
                      )}
                    </Draggable>
                  ))}
                  {provided.placeholder}
                </div>
              )}
            </Droppable>
          </div>
        </div>
        <SidebarClose />
      </div>
    </div>
  )
}

function Loading({ setting }) {
  const { style } = setting

  if (style === 'one') {
    return (
      <div
        className="loading-wrap"
        style={{
          position: 'static',
        }}
      >
        <div className="loading-bar">loading</div>
      </div>
    )
  }

  return (
    <div className="loading-wrap">
      <div className="loading-bar mb-2">loading</div>
      <div className="loading-bar mb-4">loading</div>
      <div className="loading-bar mb-2">loading</div>
      <div className="loading-bar">loading</div>
    </div>
  )
}

PersonLabel.propTypes = {
  setting: PropTypes.shape().isRequired,
}

ComponentDetail.propTypes = {
  setting: PropTypes.shape().isRequired,
}

Component.propTypes = {
  setting: PropTypes.shape().isRequired,
}

DragWrapper.propTypes = {
  setting: PropTypes.shape().isRequired,
}

Loading.propTypes = {
  setting: PropTypes.shape().isRequired,
}

export default DragWrapper
